import React from 'react'
import Profile from '../components/Dashboard/Profile'

function Dashboard() {
  return (
    <Profile/>
  )
}

export default Dashboard